import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const DiamondIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.58579 2.91421C9.36683 2.13317 10.6332 2.13316 11.4142 2.91421L17.0858 8.58579C17.8668 9.36683 17.8668 10.6332 17.0858 11.4142L11.4142 17.0858C10.6332 17.8668 9.36684 17.8668 8.58579 17.0858L2.91421 11.4142C2.13317 10.6332 2.13316 9.36684 2.91421 8.58579L8.58579 2.91421Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </SvgIcon>
  );
};
